export const NavigationData = {
  home: { name: 'Home', href: '/', 'aria-label': 'Navigate to Home' },
  docs: {
    name: 'Docs',
    href: '/docs/',
    'aria-label': 'Navigate to Docs',
  },
  contact: {
    name: 'Contact',
    href: 'https://www.imandra.ai/contact',
    'aria-label': 'Contact us',
  },
  login: {
    name: 'Login',
    href: 'https://universe.imandra.ai/login?return_to=%2Fuser%2Fhome',
    'aria-label': 'Login to Imandra Universe',
  },
  signup: {
    name: 'Start now',
    href: 'https://universe.imandra.ai/sign-up',
    'aria-label': 'Start now - Sign up',
  },
}

export const DataFooterLinks = {
  links: {
    title: 'Quick Links',
    items: [
      {
        href: '/',
        'aria-label': 'Navigate to Home',
        text: 'Home',
      },
      {
        href: '/docs/',
        'aria-label': 'Navigate to Docs',
        text: 'Docs',
      },
      {
        href: 'https://www.imandra.ai/contact',
        'aria-label': 'Contact us',
        text: 'Contact',
      },
      //   {
      //     href: '/about/',
      //     'aria-label': 'Navigate to About',
      //     text: 'About',
      //   },
    ],
  },
  connect: {
    title: 'Connect',
    items: [
      {
        href: 'https://github.com/imandra-ai',
        'aria-label': 'Visit Imandra on GitHub',
        text: 'GitHub',
      },
      {
        href: 'https://twitter.com/imandra_ai',
        'aria-label': 'Visit Imandra on X (Twitter)',
        text: 'X',
      },
      {
        href: 'https://linkedin.com/company/imandra',
        'aria-label': 'Visit Imandra on LinkedIn',
        text: 'LinkedIn',
      },
    ],
  },
}
